const ModalityType = Object.freeze({
  online: 'online',
  onSite: 'on-site',
  hybrid: 'hybrid',
});
export default ModalityType;
